<template>
  <div
    v-shortkey="['ctrl', 'shift', 'u']"
    class="user-nav-component"
    @shortkey="showUserConfModal"
  >
    <b-navbar-nav
      v-if="!responsive"
      id="popOverContainer"
      class="user-nav"
    >
      <b-nav-item
        id="popOverTarget"
        class="d-flex align-items-center"
        qa="userNav-popover"
      >
        <div class="d-flex align-items-center">
          <b-button class="tracking-btn-user">
            <i
              class="fas fa-user"
              aria-hidden="true"
            />
          </b-button>
          <img
            v-if="userLastProfileImage"
            class="un-thumbnail"
            :src="userLastProfileImage"
            aria-hidden="true"
            alt="user-profile-image"
          >
          <img
            v-else
            class="un-thumbnail"
            src="@/img/user-img.png"
            aria-hidden="true"
            alt="user-profile-image"
          >
          <span class="mr-2 username d-inline-block text-truncate">{{ fullName }}</span>
        </div>
      </b-nav-item>
      <b-popover
        target="popOverTarget"
        placement="bottom"
        container="popOverContainer"
        triggers="click blur"
      >
        <b-list-group
          class="user-nav-list-group"
          flush
        >
          <b-list-group-item
            id="usernavConfig"
            button
            class="profile-tracking d-flex align-items-center justify-content-center p-0"
          >
            <div
              class="d-flex flex-column justify-content-center align-items-center"
              style="position:relative;width:100%;"
            >
              <div
                class="d-flex flex-column justify-content-center align-items-center mt-4 mb-2"
                style="z-index:2"
              >
                <img
                  v-if="userLastProfileImage"
                  class="card-photo-pop"
                  :src="userLastProfileImage"
                  aria-hidden="true"
                  alt="user-profile-image-pop"
                >
                <img
                  v-else
                  class="card-photo-pop"
                  src="@/img/user-img.png"
                  aria-hidden="true"
                  alt="user-profile-image-pop"
                >
                <span class="full-name">{{ fullName }}</span>
                <small style="text-transform:uppercase">{{ job }}</small>
                <small v-if="userInformation">{{ $t('global.lastAccess') }}: {{ userInformation.penultimateAccess | datetime }}</small>
              </div>
              <div class="background-card" />
            </div>
          </b-list-group-item>
          <div
            v-if="!touchMode"
            class="user-nav-items"
          >
            <ul>
              <li
                @click="showUserConfModal"
              >
                <div>
                  <i
                    class="far fa-user-cog main mr-2"
                    aria-hidden="true"
                  />
                  <span class="secondary-color">{{ $t('global.profile') }}</span>
                </div>
              </li>
              <li
                v-if="userInformation && isPersonnel"
                @click="showUserCalendarModal"
              >
                <div>
                  <i
                    class="far fa-calendar-alt main mr-2"
                    aria-hidden="true"
                  />
                  <span class="secondary-color">{{ $t('global.userCalendar') }}</span>
                </div>
              </li>
            </ul>
          </div>
        </b-list-group>
      </b-popover>
    </b-navbar-nav>
    <div
      v-if="responsive"
      class="responsive-view"
    >
      <b-container class="p-3">
        <b-row
          :aria-expanded="visible ? 'true' : 'false'"
          aria-controls="collapse-user-options"
          class="w-100 is-cursor-pointer"
          @click="visible = !visible"
        >
          <b-col
            cols="auto"
            class="d-flex align-items-center justify-content-center pl-4 pr-1"
          >
            <img
              v-if="userLastProfileImage"
              class="card-photo-pop"
              :src="userLastProfileImage"
              aria-hidden="true"
              alt="user-profile-image-responsive"
            >
            <img
              v-else
              class="card-photo-pop"
              src="@/img/user-img.png"
              aria-hidden="true"
              alt="user-profile-image-responsive"
            >
          </b-col>
          <b-col class="user-info d-flex flex-column align-content-start">
            <span class="full-name text-left">{{ fullName }}</span>
            <small style="text-transform:uppercase">{{ job }}</small>
            <small v-if="userInformation">{{ $t('global.lastAccess') }}: {{ userInformation.penultimateAccess | datetime }}</small>
          </b-col>
          <b-col
            cols="auto"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              v-if="!touchMode"
              class="btn__icon btn__icon--primary "
            >
              <i
                v-if="!visible"
                class="far fa-chevron-down"
                aria-hidden="true"
              />
              <i
                v-if="visible"
                class="far fa-chevron-up"
                aria-hidden="true"
              />
            </b-button>
          </b-col>
        </b-row>
      </b-container>
      <b-collapse
        id="collapse-user-options"
        v-model="visible"
      >
        <div class="user-nav-items">
          <ul>
            <li @click="showUserConfModal">
              <div class="d-flex align-items-center">
                <i
                  class="far fa-user-cog main mr-2"
                  aria-hidden="true"
                />
                <span class="secondary-color">{{ $t('global.profile') }}</span>
              </div>
            </li>
            <li
              v-if="userInformation && isPersonnel"
              @click="showUserCalendarModal"
            >
              <div class="d-flex align-items-center">
                <i
                  class="far fa-calendar-alt main mr-2"
                  aria-hidden="true"
                />
                <span class="secondary-color">{{ $t('global.userCalendar') }}</span>
              </div>
            </li>
          </ul>
        </div>
      </b-collapse>
    </div>
    <modal-logout ref="logoutModal" />
    <modal-wrapper ref="userConfModalWrapper">
      <modal-user-conf :tab-position="printersTab" />
    </modal-wrapper>
    <modal-wrapper ref="userCalendarModalWrapper">
      <modal-user-calendar />
    </modal-wrapper>
  </div>
</template>

<script>
import sessionStore from '@/session/sessionStore'
import ModalLogout from '@/components/modals/ModalLogout'
import ModalUserConf from '@/components/userConfiguration/ModalUserConf'
import ModalUserCalendar from '@/components/userConfiguration/ModalUserCalendar'
import { userappProfileImageService } from '@/api/services/common/userapp-profile-image/common-userapp-profile-image.service'
import AttachmentResource from '@/api/resources/attachment/attachmentResource'
import { UserType } from '@/api/resources/common/initialization/common-initialization.dto.ts'

export default {
    name: 'UserNav',
    components: {
        ModalLogout,
        ModalUserConf,
        ModalUserCalendar
    },
    props: {
        responsive: { type: Boolean, default: false },
        touchMode: { type: Boolean, default: false }
    },
    data() {
        return {
            sessionState: sessionStore.state,
            visible: false,
            printersTab: null
        }
    },
    computed: {
        fullName() {
            if (this.userInformation) {
                if (this.userInformation.petitioner) {
                    return [this.userInformation.petitioner.name,
                        this.userInformation.petitioner.middleName,
                        this.userInformation.petitioner.surname1,
                        this.userInformation.petitioner.surname2].join(' ')
                }
                if (this.userInformation.personnel) {
                    return [this.userInformation.personnel.name,
                        this.userInformation.personnel.middleName,
                        this.userInformation.personnel.surname1,
                        this.userInformation.personnel.surname2].join(' ')
                }
            }
            return ''
        },
        job() {
            if (this.userInformation) {
                if (this.userInformation.petitioner) {
                    return this.$tc('global.petitionerJob')
                }
                if (this.userInformation.personnel) {
                    return this.userInformation.personnel.job?.translatedName ?? ''
                }
            }
            return ''
        },
        userLastProfileImage() {
            return this.$store.getters.userLastProfileImage
        },
        userInformation() {
            return this.$store.getters.userInformation
        },
        isPersonnel() {
            return this.$store.getters.userInformation.userType === UserType.PERSONNEL
        }
    },
    async created() {
        await this.updateUserLastProfileImage()
    },
    methods: {
        showLogoutModal() {
            this.$refs.logoutModal.show()
        },
        async showUserConfModal() {
            await this.$refs.userConfModalWrapper.show()
        },
        showUserCalendarModal() {
            this.$refs.userCalendarModalWrapper.show()
        },
        async updateUserLastProfileImage() {
            const response = await this.$_toCallSecure(
                userappProfileImageService.getUserProfileImage(),
                error => this.$_handleAxiosError(error, [404]))
            if (response) {
                const attachmentResource = new AttachmentResource()
                const base64LastProfileImage = await attachmentResource.fileToBase64(response)
                this.$store.commit('updateUserLastProfileImage', base64LastProfileImage)
            }
        }
    }
}
</script>

<style lang="scss">
.user-nav-component .responsive-view .user-nav-items {
    border-top: 1px solid vt-color(general-border);
}
.user-nav-component .responsive-view .user-nav-items li {
    padding-left: 30px;
}
.user-nav-component .responsive-view .user-nav-items li i {
    margin-right: 15px !important;
}
.user-nav-component .responsive-view .user-info {
    line-height: 15px;
}
.user-section-responsive .user-nav-component {
    margin-left: 0 !important;
}
.user-nav-items ul {
    padding: 0;
    margin: 0;
}
.user-nav-items ul li {
    list-style: none;
    padding: 10px 15px;
    border-bottom: 1px solid vt-color(general-border);
    cursor: pointer;
    transition: .3s;
}
.user-nav-items ul li:last-child {
    border-bottom: none;
}
.user-nav-items ul li:hover {
    background-color: vt-color(light-primary);
}
.user-nav-items ul li i {
    font-size: font-size(very-normal);
    width: 20px;
}
.user-nav .popover-body {
  margin: 0 !important;
  width: 250px;
}

.card-photo-pop {
    width: 40px !important;
    height: 40px;
    border-radius: 50%;
}
</style>

<style scoped lang="scss">
.btns-row i {
  font-size: font-size(big);
}

.last-row {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.last-row a {
  font-size: font-size(very-tiny);
}

.full-name {
  color: vt-color(dark-text);
  text-align: center;
}

.btn-user-outline {
  background: transparent;
  color: vt-color(primary);
  border-color: vt-color(primary);
}

.btn-user-outline:hover,
.btn-user-outline:active {
  background: vt-color(primary);
  color: vt-color(white-light);
  border-color: vt-color(white-light);
}

.btn-user-fill {
  background: vt-color(primary);
  color: vt-color(white-light);
  border-color: vt-color(white-light);
}

.btn-user-fill:hover {
  background: vt-color(alt-primary);
  color: vt-color(white-light);
  border-color: vt-color(white-light);
}

.profile-tracking:hover {
  background: transparent;
}

.profile-tracking {
  cursor: default;
  background: vt-color(usercard-bg) !important;
}

.profile-tracking span {
  color: vt-color(negative-text);
}

.profile-tracking small {
  color: vt-color(base-text) !important;
}

.background-card {
  width: 100%;
  height: 40px;
  position: absolute;
  /* Línea comentada por si finalmente se opta a background tipo imagen */
  /* background: url('../../img/profilebg.jpg'); */
  background-size: 100%;
  top: 0;
}

.tracking-btn-user {
  display: none;
}

.username {
  width: 100px;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: vt-color(primary);
  transition: 0.3s;
}

.username:hover {
  color: vt-color(dark-primary);
}

.un-thumbnail {
  border-radius: 16px;
  margin-right: 12px;
  height: 25px;
  width: 25px;
}

.un-chevron {
  margin-top: 18px;
  color: #c1c7d0;
}

.user-nav {
  /*@include media-breakpoint-up(xl) {
    padding-left: 10px;
  }*/
    ::v-deep .popover {
    left: -30px !important; // the component uses element style. So I have to override with !important
  }
    ::v-deep .popover-header {
    padding: 26px 27px 15px 32px;
  }
}

.user-nav-list-group {
  width: 240px;
  .list-group-item {
    display: flex;
  }
}

.un-button-label {
  margin-left: 11px;
  margin-right: auto;
  padding-right: 11px;
}

.laboratory-label {
  margin-left: 11px;
  margin-right: auto;
  padding-right: 11px;
  font-weight: bold;
}

.group-hover:hover {
  background: vt-color(light-primary);
}

.group-hover span {
  font-size: 0.9rem !important;
}

.group-hover .icon-profile {
  font-size: 1rem !important;
}
</style>
